import { env } from '../config/env';

const APP_BASE_URL = 'https://uu.me';

export const getDashboardUrl = () => `${APP_BASE_URL}/?post_login=dashboard`;

export const buildLoginRedirectUrl = (returnUrl = getDashboardUrl()) =>
  `${env.API_BASE_URL}/static/login.html?redir=${encodeURIComponent(returnUrl)}`;
